const permissionTypes = [
  { label: 'Permiso con Goce', value: 'with_pay' },
  { label: 'Permiso sin Goce', value: 'without_pay' },
  { label: 'Día Administrativo', value: 'administrative_days' }
];

export default permissionTypes;
